import store from '@/store';
import { sendDTMF } from '@/weon/web-rtc/WeonWebRTC.js';
import i18n from '@/i18n';

export default class InternalCallEvent {
  constructor(body) {
    const agentAckCall = store.state.attendance.Attendance.agentAckCall;

    if (agentAckCall) {
      console.log('[COLLEAGUES] - ACKCALL AUTO-ACCEPT');
      sendDTMF('#', false, i18n.t('webRTC.dialpad.ackCallRequestAcceptCall'));
    }
  }
}
